import { useCallback } from "react";
import { createTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { UIFlightData, UIIncludedProductBySegmentCompressed } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_web_remove_baggage_weight_size_fd",
  stages: {
    main: 1,
    desktop: 2,
    mobile: 3,
    meta: 4,
    direct: 5,
    baggage_allowance_equal: 6,
    baggage_allowance_differ_type: 7,
    baggage_allowance_differ_weight_size: 8,
    no_extra_baggage: 9
  },
  defaultStage: 1,
  goals: {
    close_fd: 1
  }
});

export const useTrackRemoveBaggageWeightSizeFd = (
  flight: UIFlightData,
  includedProducts: UIIncludedProductBySegmentCompressed | undefined,
  includedProductsCompressed: UIIncludedProductBySegmentCompressed | undefined
) => {
  const { isDesktop, isMobile, isMeta, isDirect } = useProfiler();

  return useCallback(() => {
    const variant = utils.trackWithDefaultStage();

    isDesktop() && utils.stages.desktop();
    isMobile() && utils.stages.mobile();
    isMeta() && utils.stages.meta();
    isDirect() && utils.stages.direct();

    if (includedProducts && includedProductsCompressed) {
      if (includedProducts.segments.length === 1) {
        utils.stages.baggage_allowance_equal();
      } else if (includedProductsCompressed.segments.length > 1) {
        utils.stages.baggage_allowance_differ_type();
      } else if (includedProducts.segments.length > 1) {
        utils.stages.baggage_allowance_differ_weight_size();
      }
    }

    if (
      !flight.ancillaries?.cabinBaggage &&
      !flight.ancillaries?.cabinBaggagePerTraveller &&
      !flight.ancillaries?.checkedInBaggage
    ) {
      utils.stages.no_extra_baggage();
    }

    return variant;
  }, [
    flight.ancillaries?.cabinBaggage,
    flight.ancillaries?.cabinBaggagePerTraveller,
    flight.ancillaries?.checkedInBaggage,
    includedProducts,
    includedProductsCompressed,
    isDesktop,
    isDirect,
    isMeta,
    isMobile
  ]);
};

export default utils;
